import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from 'lucide-react';
import { clinic } from '../data/clinic';
export function CtaBand() {
  return <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8" data-id="element-88" data-mp="cjvnvomcsddd">
      <div className="grid items-center gap-8 rounded-3xl bg-primary px-8 py-12 text-white sm:px-12 lg:grid-cols-[1.4fr_1fr] lg:py-14" data-id="element-89" data-mp="hfkfn5s4spz4">
        <div data-id="element-90" data-mp="mdvslpdq3glk">
          <h2 className="font-display text-3xl font-semibold tracking-tight sm:text-4xl" data-id="element-91" data-mp="rfl1aydh3i6h">Wilt u weten wat wij voor u kunnen doen?</h2>
          <p className="mt-4 max-w-xl text-lg leading-relaxed text-white/80" data-id="element-92" data-mp="vfvaejwkaopk">
            Neem contact met ons op. U kunt binnen één tot vier weken bij ons terecht voor een intake.
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:justify-end" data-id="element-93" data-mp="155eufsw0gom0">
          <a href={clinic.phoneHref} className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white px-6 py-3.5 text-[15px] font-semibold text-primary transition-colors duration-150 hover:bg-primary-soft" data-id="element-94" data-mp="1a6lzvlaolbpi">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-95" data-mp="1u8a4wnv0fspv" />
            {clinic.phone}
          </a>
          <Link to="/contact" className="flex items-center justify-center whitespace-nowrap rounded-full border border-white/40 px-6 py-3.5 text-[15px] font-semibold text-white transition-colors duration-150 hover:bg-white/10" data-id="element-96" data-mp="1p9781qp6ossz">
            Stuur een bericht
          </Link>
        </div>
      </div>
    </section>;
}